// extracted by mini-css-extract-plugin
export default {"audio-tag":"lsf-audio-tag"};